import moment from "moment";
import { app } from "../services";

const initCatalogs = async function (catalog, callback) {
  // lastUpdate puede venir como string/Date/moment.
  // Aseguramos Date válida para Sequelize/MySQL (DATETIME)
  const since = catalog?.lastUpdate
    ? new Date(catalog.lastUpdate) // ✅ Date, NO getTime()
    : new Date("1970-01-01T00:00:00.000Z");

  const response = await app.service(catalog.service).find({
    query: {
      $limit: 20000,
      $sort: { updatedAt: 1 }, // opcional pero recomendable
      updatedAt: {
        $gt: since, // ✅ Date
      },
    },
  });

  callback({
    ...catalog,
    lastUpdate: moment().toISOString(), // ✅ guarda como ISO para consistencia
    data: response.data || [],
  });
};

const common = { initCatalogs };
export default common;
